import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat, priceM2Format} from "@pg-mono/string-utils";
import {getPriceUnit} from "@pg-rp/common-types";

import {IVariable} from "../../types/IVariable";
import {IPropertyDetailDTO} from "../../types/property/IPropertyDetailDTO";
import {HomematchPropertyCardDetailGallery} from "./HomematchPropertyCardDetailGallery";
import {HomematchPropertyCardDetailInfoTable} from "./HomematchPropertyCardDetailInfoTable";
import {HomematchPropertyCardDetailOverviewLocation} from "./HomematchPropertyCardDetailOverviewLocation";
import {HomematchPropertyCardDetailOverviewSummary} from "./HomematchPropertyCardDetailOverviewSummary";

import * as styles from "./HomematchPropertyCardDetailOverview.module.css";

interface IProps {
    property: IPropertyDetailDTO;
    priceHighlightColor?: string;
    quarterTypes?: IVariable[];
}

export const HomematchPropertyCardDetailOverview = (props: IProps) => {
    const {priceHighlightColor, property, quarterTypes} = props;

    const price = property.price;
    const priceM2 = property.price_m2;
    const hasPrice = price != null;
    const priceUnit = getPriceUnit(property.region.country);

    return (
        <section className={styles.section}>
            <div className={styles.imageColumn}>
                <HomematchPropertyCardDetailGallery property={property} />
            </div>

            <div className={styles.infoColumn}>
                {hasPrice && (
                    <div className={styles.priceRow}>
                        <Text as="p" variant="headline_3">
                            <Highlight color={priceHighlightColor}>
                                {priceFormat(price, {unit: ""})}

                                <Text as="span" strong variant="info_txt_1">
                                    {priceUnit}
                                </Text>
                            </Highlight>
                        </Text>

                        {!!priceM2 && (
                            <Text strong variant="info_txt_1">
                                {priceM2Format(priceM2, {unit: priceUnit})}
                            </Text>
                        )}
                    </div>
                )}

                <div className={styles.infoContent}>
                    <HomematchPropertyCardDetailOverviewLocation property={property} />

                    <HomematchPropertyCardDetailOverviewSummary property={property} />

                    <HomematchPropertyCardDetailInfoTable property={property} quarterTypes={quarterTypes} />
                </div>
            </div>
        </section>
    );
};
import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat, priceM2Format} from "@pg-mono/string-utils";
import {getPriceUnit} from "@pg-rp/common-types";

import {IVariable} from "../../types/IVariable";
import {IPropertyDetailDTO} from "../../types/property/IPropertyDetailDTO";
import {HomematchPropertyCardDetailGallery} from "./HomematchPropertyCardDetailGallery";
import {HomematchPropertyCardDetailInfoTable} from "./HomematchPropertyCardDetailInfoTable";
import {HomematchPropertyCardDetailOverviewLocation} from "./HomematchPropertyCardDetailOverviewLocation";
import {HomematchPropertyCardDetailOverviewSummary} from "./HomematchPropertyCardDetailOverviewSummary";

import * as styles from "./HomematchPropertyCardDetailOverview.module.css";

interface IProps {
    property: IPropertyDetailDTO;
    priceHighlightColor?: string;
    quarterTypes?: IVariable[];
}

export const HomematchPropertyCardDetailOverview = (props: IProps) => {
    const {priceHighlightColor, property, quarterTypes} = props;

    const price = property.price;
    const priceM2 = property.price_m2;
    const hasPrice = price != null;
    const priceUnit = getPriceUnit(property.region.country);

    return (
        <section className={styles.section}>
            <div className={styles.imageColumn}>
                <HomematchPropertyCardDetailGallery property={property} />
            </div>

            <div className={styles.infoColumn}>
                {hasPrice && (
                    <div className={styles.priceRow}>
                        <Text as="p" variant="headline_3">
                            <Highlight color={priceHighlightColor}>
                                {priceFormat(price, {unit: ""})}

                                <Text as="span" strong variant="info_txt_1">
                                    {priceUnit}
                                </Text>
                            </Highlight>
                        </Text>

                        {!!priceM2 && (
                            <Text strong variant="info_txt_1">
                                {priceM2Format(priceM2, {unit: priceUnit})}
                            </Text>
                        )}
                    </div>
                )}

                <div className={styles.infoContent}>
                    <HomematchPropertyCardDetailOverviewLocation property={property} />

                    <HomematchPropertyCardDetailOverviewSummary property={property} />

                    <HomematchPropertyCardDetailInfoTable property={property} quarterTypes={quarterTypes} />
                </div>
            </div>
        </section>
    );
};
